import React from 'react';
import { useRecoilValue } from 'recoil';

import { Badge } from '@/components/badge';
import { getServiceLineNames } from '@/lib/models/lines/utils/get-line-service-ids';
import { getLinesByIds } from '@/state/lines';
import { tv } from '@/utils/styles';

export interface LineNameListProps {
  lineIds: string[];
  carrierIds: string[];
}

const LineNameList = ({ lineIds, carrierIds }: LineNameListProps) => {
  const lines = useRecoilValue(getLinesByIds(lineIds));
  const lineServiceNames = lines.map((line) => getServiceLineNames(line, carrierIds));

  const { base, lineBadge, arrow } = styles();

  return (
    <span className={base()}>
      {lineServiceNames.map((name, index) => (
        <React.Fragment key={`line-${index}`}>
          {index > 0 && <span className={arrow()}>→</span>}
          <Badge variant="light" className={lineBadge()}>
            {name}
          </Badge>
        </React.Fragment>
      ))}
    </span>
  );
};

const styles = tv({
  slots: {
    base: 'max-w-[250px] text-ellipsis',
    lineBadge: 'normal text-xs font-medium italic leading-normal',
    arrow: 'text-medium mx-1',
  },
});

export { LineNameList };
